import { render, staticRenderFns } from "./AutomatedMarketing.vue?vue&type=template&id=47b7823b&scoped=true&"
import script from "./AutomatedMarketing.vue?vue&type=script&lang=js&"
export * from "./AutomatedMarketing.vue?vue&type=script&lang=js&"
import style0 from "./AutomatedMarketing.vue?vue&type=style&index=0&id=47b7823b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b7823b",
  null
  
)

export default component.exports